import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AuthProvider, useAuth } from '@/lib/auth';
import AppShell from '@/components/AppShell';
import LoginPage from '@/pages/LoginPage';
import OverviewPage from '@/pages/OverviewPage';
import DevicesPage from '@/pages/DevicesPage';
import EventsPage from '@/pages/EventsPage';
import MediaPage from '@/pages/MediaPage';
import DatasetsPage from '@/pages/DatasetsPage';
import BackupPage from '@/pages/BackupPage';
import OtaPage from '@/pages/OtaPage';
import SitesPage from '@/pages/SitesPage';
import UsersPage from '@/pages/UsersPage';
import AssistantSettingsPage from '@/pages/AssistantSettingsPage';

export default function App() {
  return (
    <AuthProvider>
      <Routed />
    </AuthProvider>
  );
}

function Routed() {
  const { user, loading } = useAuth();

  /* 開機問 /auth/me 期間先不要渲染任何東西，否則帶著有效 cookie 重整
     會先閃一下登入頁再跳回來。 */
  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  const isAdmin = user.role === 'admin';

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/datasets" element={<DatasetsPage />} />
        {/* 管理者專屬頁：非管理者直接導回總覽，不要讓網址列繞過側欄的可見性 */}
        <Route
          path="/backup"
          element={isAdmin ? <BackupPage /> : <Navigate to="/overview" replace />}
        />
        <Route
          path="/ota"
          element={isAdmin ? <OtaPage /> : <Navigate to="/overview" replace />}
        />
        <Route
          path="/sites"
          element={isAdmin ? <SitesPage /> : <Navigate to="/overview" replace />}
        />
        <Route
          path="/users"
          element={isAdmin ? <UsersPage /> : <Navigate to="/overview" replace />}
        />
        <Route
          path="/assistant"
          element={isAdmin ? <AssistantSettingsPage /> : <Navigate to="/overview" replace />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}
